import styled from "styled-components";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps } from "react-builder";
import {
  ChaptersElearnProvider,
  useLevelsData,
  useLanguage,
  userDataContext,
} from "../../providers/ElearningV2";
import { useContext, useEffect, useState } from "react";
import { ConfigsProvider, ConfigContext } from "react-builder";
import { useProductApi } from "../../custom-hooks/useProductApi";
import { ElearnUserData } from "../../types/e-learning-types";

@AttributeGroup({
  title: "ChaptersBuilderV2",
  blockName: "ChaptersBuilderV2",
  module: "elearning",
  icon: "query",
})
export class ChaptersBuilderAttributes extends Attribute {
  @AttributeProperty({ type: "String" })
  levelId: string = "";

  @AttributeProperty({ type: "String" })
  chapterId?: string;
}

function ChaptersBuilder(props: ComponentProps<ChaptersBuilderAttributes>) {
  const content = useContext(ConfigContext);
  const userLanguage = useLanguage();
  const { updateUserDataArrays, watchedChapters, watchedLessons } = useContext(userDataContext);
  const userDataAPI = useProductApi<ElearnUserData>();
  const chapterIdFilter = props.attributes.chapterId
    ? content.getContent(props.attributes.chapterId)
    : "";

  const isWatched = (chapterId: string) => {
    if (!watchedChapters || !watchedChapters.length) return false;
    return !!watchedChapters?.find((c) => c == chapterId);
  };

  const setWatchedFirstLesson = async (lessonId: string) => {
    try {
      if (!userDataAPI) return;
      await userDataAPI.post(`elearn/ElearnUserData/${lessonId}/watched`);
    } catch (error) {
      console.log("error: ", error);
    }
    updateUserDataArrays("watchedLessons", [...watchedLessons, lessonId]);
  };

  return (
    <ChaptersElearnProvider
      loader={<></>}
      levelId={content.parseContent(props.attributes.levelId)}
      {...props}
    >
      {(chapters) => (
        <>
          <ConfigsProvider
            configJson={{
              chapters: chapters
                ?.filter((l) => !chapterIdFilter || l._id == chapterIdFilter)
                ?.map((c) => {
                  const translationKey = c.translations[userLanguage] ? userLanguage : "EN";
                  const translation = c.translations[translationKey];
                  return {
                    ...c,
                    name: translation.translatedName,
                    descriptionType: translation.translatedDescriptionType || "",
                    id: c._id,
                    lessonCount: c.lessons.length,
                    rate: (c.score / c.totalVotes).toFixed(1),
                    tagList: (translation?.translatedTags ?? "").split(","),
                    levelId: c.elearnLevel,
                    tags: translation.translatedTags || "",
                    target: translation.translatedTarget || "",
                    thumbCardsUrl: c.thumbCards.url,
                    thumbUrl: c.thumb.url,
                    totalVotes: c.totalVotes,
                    isWatched: isWatched(c._id),
                    setWatchedFirstLesson: () => setWatchedFirstLesson(c.lessons[0]),
                  };
                })
                ?.sort(),
            }}
          >
            <>{props.children}</>
          </ConfigsProvider>
        </>
      )}
    </ChaptersElearnProvider>
  );
}

ChaptersBuilder.prototype.Props = ChaptersBuilderAttributes;

export default ChaptersBuilder;
